import { render, staticRenderFns } from "./NetworkStatus.vue?vue&type=template&id=4ef384c6"
import script from "./NetworkStatus.vue?vue&type=script&lang=js"
export * from "./NetworkStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports